
















































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import axios from 'axios'

import ProductFilters from './components/ProductFilters.vue'
import ProductOverview from './components/ProductOverview.vue'
import ProductTags from './components/ProductTags.vue'
import SiteBreadcrumb from './components/SiteBreadcrumb.vue'
import ProductSort from './components/ProductSort.vue'
import ProductsPaging from './components/ProductsPaging.vue'
// Atoms
import FilterToggle from './components/atoms/FilterToggle.vue'
import VueSmoothScroll from 'vue2-smooth-scroll'
import ProductCard1 from './components/cardtemplates/ProductCard1.vue'

Vue.use(VueSmoothScroll)

@Component({
  components: {
    ProductFilters,
    ProductOverview,
    ProductTags,
    SiteBreadcrumb,
    ProductSort,
    ProductsPaging,
    FilterToggle,
    ProductCard1
  }
})
export default class App extends Vue {
  filters: Array<Filter> = [];
  products: Array<Product> = [];
  totalProducts = 0;
  totalFoundProducts = 0;
  breadcrumbs: Array<Breadcrumb> = [];
  sort: Array<Sort> = [];
  title = '';
  description = '';
  selectedSort = 0;
  culture = document.documentElement.lang;
  queryParams = window.location.search.replace('?', '');
  storeableFilter: Array<StoreableFilter> = [];
  paging = 1;
  nodeId = 0;
  currentpage = 1;
  windowWidth = 0;
  compareProducts = [];

  filterFormId = 'filter-form';
  filterIsOpen = true;
  // eslint-disable-next-line
  configElement: any = document.getElementById("config");
  config = JSON.parse(this.configElement.innerHTML);
  baseURL: string = this.config.baseURL;
  maxOptions: number =
    typeof this.config.data?.MaxOptions !== 'undefined'
      ? this.config.data.MaxOptions
      : 9999;

  showBreadCrumbs: boolean = this.config.data?.ShowBreadCrumbs || false;
  showTotalResults: boolean = this.config.data?.ShowTotalResults || true;
  showFilterTags: boolean = this.config.data?.ShowFilterTags || true;
  showSorting: boolean = this.config.data?.ShowSorting || true;
  showSearchBox: boolean = this.config.data?.ShowSearchBox || false;
  showCounts: boolean = this.config.data?.ShowCounts || false;
  showItemsWithNoResults: boolean =
    typeof this.config.data?.ShowItemsWithNoResults !== 'undefined'
      ? this.config.data.ShowItemsWithNoResults
      : true;

  showClearAll: boolean = this.config.data?.ShowClearAll || false;
  useInfoPopOver: boolean = this.config.data?.UseInfoPopOver || false;
  filterVisible: any = false;
  searchQuery = '';
  init = true;
  isLoading = true;
  appMode = 'desktop';
  filterStoreObjects = window.localStorage.getItem('filterstore') || '';
  filteredProducts = [];
  @Ref() readonly productFilters!: ProductFilters;

  async mounted () {
    this.setFilterVariables(this.config)
    this.setInitialFilters()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    const options = {
      rootMargin: '-300px 0px'
    }

    const observer = new IntersectionObserver(this.handleIntersect, options)
    observer.observe(document.getElementById('vue-overview')!)

    if (
      location.search.indexOf('store=true') !== -1 &&
      typeof this.filterStoreObjects === 'string' &&
      this.filterStoreObjects !== ''
    ) {
      this.storeableFilter = JSON.parse(this.filterStoreObjects)
      await axios
        .post(this.baseURL, this.storeableFilter[0])
        .then((response) => {
          this.setFilterVariables(response)
          this.getFilteredProducts()
        })
    } else if (!this.config.data) {
      const prefix = this.baseURL.indexOf('?') === -1 ? '?' : '&'
      axios
        .get(
          `${this.baseURL}${prefix}culture=${this.culture}&${this.queryParams}`
        )
        .then((response) => {
          this.setFilterVariables(response)
          this.getFilteredProducts()
        })
    }
    this.init = false
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }

  private handleIntersect (
    intersectionObserverEntryies: any,
    IntersectionObserver: any
  ) {
    this.filterVisible = intersectionObserverEntryies.some(
      (x: any) => x.isIntersecting
    ) as boolean
  }

  private handleResize () {
    this.windowWidth = window.innerWidth

    if (this.windowWidth < 768 && this.appMode === 'desktop') {
      this.filterIsOpen = false
      this.appMode = 'mobile'
    } else if (this.windowWidth >= 768 && this.appMode === 'mobile') {
      this.filterIsOpen = true
      this.appMode = 'desktop'
    }
  }
  // eslint-disable-next-line
  private setFilterVariables(response: any) {
    this.filters = response.data.Filters
    this.products = response.data.Products
    this.totalProducts = response.data.TotalProducts
    this.totalFoundProducts = response.data.TotalFoundProducts
    this.filteredProducts = response.data.Products
    this.breadcrumbs = response.data.CrumbPath
    this.selectedSort = response.data.SelectedSort
    this.sort = response.data.Sort
    this.title = response.data.Title
    this.description = response.data.Description
    this.paging = response.data.Paging
    this.nodeId = response.data.NodeId
    this.currentpage = response.data.CurrentPage
    this.showBreadCrumbs = response.data.ShowBreadCrumbs
    this.showTotalResults = response.data.ShowTotalResults
    this.showFilterTags = response.data.ShowFilterTags
    this.showSorting = response.data.ShowSorting
    this.showSearchBox = response.data.ShowSearchBox
    this.showCounts = response.data.ShowCounts
    // this.showItemsWithNoResults = response.data.showItemsWithNoResults - Currently not available in the API - so config data is used
    this.useInfoPopOver = response.data.UseInfoPopOver
    this.isLoading = false
  }

  @Watch('searchQuery', { immediate: true })
  searchProducts () {
    if (!this.init) {
      this.getFilteredProducts()
    }
  }

  @Watch('filterIsOpen')
  noScroll () {
    if (this.filterIsOpen) {
      document.body.classList.add('f-noscroll')
    } else {
      document.body.classList.remove('f-noscroll')
    }
  }

  // query string for browser searchbar
  get queryFilters () {
    let path = ''

    this.filters.forEach((filter) => {
      let subPath = ''
      // options
      filter.Options.forEach((filterOption, index) => {
        const prefix = path && !subPath ? '&' : ''
        const prefixName =
          index !== 0 && subPath
            ? ','
            : encodeURIComponent(filter.FilterName) + '='

        if (filter.Type === 'range') {
          let rangePath = ''
          // check if values differ from default before adding to the path
          if (
            filterOption.RangeValue.length > 1 &&
            (filterOption.RangeValue[0] > filterOption.Range[0] ||
              filterOption.RangeValue[1] < filterOption.Range[1])
          ) {
            rangePath = `${filterOption.RangeValue[0]}|${filterOption.RangeValue[1]}`
          } else if (Number(filterOption.RangeValue) > filterOption.Range[0]) {
            rangePath = filterOption.RangeValue.toString()
          }

          if (rangePath !== '') {
            subPath += prefix + prefixName + encodeURIComponent(rangePath)
          }
        } else if (filterOption.Active) {
          subPath +=
            prefix + prefixName + encodeURIComponent(filterOption.Value)
        }

        // subfilters
        if (filterOption.Active && filterOption.Options.length > 0) {
          filterOption.Options.forEach((subfilterOption) => {
            if (subfilterOption.Active) {
              subPath += ',' + encodeURIComponent(subfilterOption.Value)
            }
          })
        }
      })
      path += subPath
      subPath = ''
    })
    // sorting
    if (this.selectedSort > 0) {
      const prefix = path ? '&' : ''
      path += prefix + 'Sort=' + this.selectedSort
    }
    // paging
    if (this.currentpage > 1) {
      const prefix = path ? '&' : ''
      path += prefix + 'Page=' + this.currentpage
    }

    return path
  }

  private storeFilter () {
    this.storeableFilter = [
      {
        Filters: this.getProductsFilter(),
        SearchTerm: this.searchQuery,
        Culture: this.culture,
        SelectedSort: this.selectedSort,
        Sort: this.sort,
        Products: this.products,
        TotalFoundProducts: this.totalFoundProducts,
        TotalProducts: this.totalProducts,
        CrumbPath: this.breadcrumbs,
        CurrentPage: this.currentpage,
        NodeId: this.nodeId,
        Paging: this.paging,
        Title: this.title,
        Description: this.description,
        ShowBreadCrumbs: this.showBreadCrumbs,
        ShowTotalResults: this.showTotalResults,
        ShowFilterTags: this.showFilterTags,
        ShowSorting: this.showSorting,
        ShowSearchBox: this.showSearchBox,
        ShowCounts: this.showCounts,
        ShowItemsWithNoResults: this.showItemsWithNoResults,
        UseInfoPopOver: this.useInfoPopOver
      }
    ]

    window.localStorage.setItem(
      'filterstore',
      JSON.stringify(this.storeableFilter)
    )
  }

  private getFilteredProducts () {
    this.isLoading = true
    this.storeFilter()
    this.updateFilterQuery()

    /* if (location.search.indexOf('store=true') === -1) {
      const prefix = (location.search.indexOf('?') === -1) ? '?' : '&'
      history.replaceState({ page: location.href }, '', `${location.href}${prefix}store=true`)
    } */
    axios.post(this.baseURL, this.storeableFilter[0]).then((response) => {
      if (!response.data) {
        console.error(response)
        return
      }
      this.filters = response.data.Filters
      this.filteredProducts = response.data.Products
      this.description = response.data.Description
      this.totalFoundProducts = response.data.TotalFoundProducts
      this.sort = response.data.Sort
      this.totalProducts = response.data.TotalProducts
      this.totalFoundProducts = response.data.TotalFoundProducts
      this.selectedSort = response.data.SelectedSort
      this.nodeId = response.data.NodeId
      this.paging = response.data.Paging
      this.currentpage = response.data.CurrentPage
      this.isLoading = false
    })
  }

  // Filter array to post to API
  private getProductsFilter (): Array<ProductsFilter> {
    const productsFilters: Array<ProductsFilter> = []

    this.filters.forEach((filterGroup) => {
      const filter: ProductsFilter = {
        Name: filterGroup.FilterName,
        Value: [],
        Options: [],
        Open: filterGroup.Open,
        AllOptionsVisible: filterGroup.AllOptionsVisible
      }

      filterGroup.Options.forEach((filterOption) => {
        // rangefilter
        if (typeof filterOption.RangeValue !== 'undefined') {
          if (filterOption.RangeValue.length > 1) {
            filter.Value.push(filterOption.RangeValue[0].toString())
            filter.Value.push(filterOption.RangeValue[1].toString())
          } else {
            filter.Value.push(filterOption.RangeValue.toString())
          }
        }

        // checkbox or radiobutton
        if (filterOption.Active) {
          filter.Value.push(filterOption.Value)

          filterOption.Options.forEach((filterSubOption) => {
            if (filterSubOption.Active) {
              filter.Options.push(filterSubOption.Value)
            }
          })
        }
      })

      productsFilters.push(filter)
    })

    return productsFilters
  }

  private updateFilterQuery () {
    const query = {
      search: this.searchQuery
    }
    const activeFilters = this.queryFilters
    let path = document.location.origin + document.location.pathname
    path += `${activeFilters.length > 0 ? '?' : ''}${activeFilters}`

    if (this.searchQuery !== '') {
      path += `${activeFilters.length > 0 ? '&' : '?'}search=${
        this.searchQuery
      }`
    }
    // window.history.pushState({ ...query, activeFilters }, document.title, path)
    window.history.replaceState(
      { ...query, activeFilters },
      document.title,
      path
    )
  }

  private setInitialFilters () {
    const search = document.location.search.substring(1)

    search.split('&').forEach((filterString) => {
      const filter = filterString.split('=')

      const key = filter[0]
      const value = decodeURI(filter[1])

      if (key === 'search') {
        this.searchQuery = value

        this.productFilters.setSearchQuery(value)
      } else {
        const filterGroup = this.filters.find((filter) => {
          return filter.FilterName === key
        })
        if (filterGroup) {
          const option = filterGroup.Options.find((option) => {
            return option.Value === value
          })

          if (option) {
            Vue.set(option, 'Active', true)
          }
        }
      }
    })
  }

  private clearSearch () {
    this.searchQuery = ''
    this.productFilters.setSearchQuery('')
  }

  private updateSort (value: number) {
    this.selectedSort = value
    this.getFilteredProducts()
  }

  private updatePaging (value: number) {
    this.currentpage = value
    this.scrollToTop()
    this.getFilteredProducts()
  }

  private updateFilterVisibility () {
    this.filterIsOpen = !this.filterIsOpen
  }

  private clearAllFilter () {
    this.clearSearch()

    this.filters.forEach((filter) => {
      filter.Options.forEach((filterOption) => {
        if (filter.Type === 'range') {
          // reset range slider
          if (filterOption.RangeValue.length > 1) {
            filterOption.RangeValue = filterOption.Range
          } else {
            filterOption.RangeValue = [filterOption.Range[0]]
          }
        } else if (filterOption.Active) {
          filterOption.Active = false
        }

        // subfilters
        if (
          typeof filterOption.Options !== 'undefined' &&
          filterOption.Options.length > 0
        ) {
          filterOption.Options.forEach((subfilterOption) => {
            if (subfilterOption.Active) {
              subfilterOption.Active = false
            }
          })
        }
      })
    })
    this.getFilteredProducts()
  }

  private scrollToTop () {
    this.scrollToHref('[data-top-of-overview]')
  }

  private scrollToHref (elementName: string) {
    if (!elementName) return

    const element = document.querySelector(elementName)
    if (!element) return
    const offsetMargin = window.innerWidth > 768 ? -15 : -160

    this.$smoothScroll({
      scrollTo: element,
      offset: offsetMargin
    })
  }
}
